export default {"src":"/_next/static/media/15.d83d2c93.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};